export const en = {
  'app.name': 'numsLearn',
  'app.tagline': 'Match the numbers. Beat the class.',

  'nav.play': 'Play',
  'nav.admin': 'Teacher',

  'hud.time': 'Time', 'hud.score': 'Score', 'hud.combo': 'Combo',
  'hud.left': 'Left', 'hud.adds': 'Adds', 'hud.hints': 'Hints',

  'btn.add': 'Add row', 'btn.hint': 'Hint', 'btn.restart': 'New board',
  'btn.close': 'Close', 'btn.done': 'Done', 'btn.reset': 'Reset to level default',

  'rule.equal': 'Tap two tiles with the SAME number',
  'rule.sumTo': 'Tap two tiles that add up to {n}',
  'rule.sumTo20': 'Tap two tiles that add up to {n}',
  'rule.multipleOf': 'Tap a number and one of its multiples',
  'rule.sameProduct': 'Tap two expressions with the same answer',
  'rule.equivalent': 'Tap two tiles worth the same amount',

  'level.gentle': 'Gentle', 'level.steady': 'Steady', 'level.brisk': 'Brisk',
  'level.sharp': 'Sharp', 'level.fierce': 'Fierce',

  'theme.playground': 'Playground',
  'theme.playground.desc': 'Candy pills on warm peach. Springy and forgiving — best for the youngest grades.',
  'theme.paper': 'Paper & Marker',
  'theme.paper.desc': 'Biro blue on ruled notebook. A red marker draws itself across each pair.',
  'theme.clay': 'Soft Clay',
  'theme.clay.desc': 'Pastel clay, chunky and tactile, with squash-and-stretch on every tap.',
  'theme.auto': 'Match the grade',
  'theme.auto.desc': 'Playground for Grades 1–2, Soft Clay for 3–4, Paper & Marker for 5–6.',

  'msg.cleared': 'Board cleared!',
  'msg.timeUp': "Time's up",
  'msg.noMoves': 'No moves left — add a row',
  'msg.grade': 'Grade {g}',
  'msg.level': 'Level {n}',
  'msg.match': '{a} + {b} = {t}',
  'msg.matchEq': '{a} = {b}',
  'msg.noMatch': '{a} + {b} ≠ {t}',
  'msg.noMatchEq': '{a} ≠ {b}',
  'msg.notConnected': '{a} and {b} are not connected',

  'admin.title': 'Teacher panel',
  'admin.subtitle': 'Everything the game does, in your hands.',
  'admin.theme': 'Look and feel',
  'admin.themeHelp': 'Pick the world the class plays in. Applies instantly.',
  'admin.appearance': 'Appearance',
  'admin.mode': 'Brightness', 'admin.modeLight': 'Light', 'admin.modeDark': 'Dark', 'admin.modeAuto': 'Auto',
  'admin.lang': 'Language', 'admin.numerals': 'Numerals',
  'admin.sound': 'Sound effects',
  'admin.soundHelp': 'Off by default — thirty devices chirping at once is a lot of classroom. On a projector, turn it on.',
  'admin.numLatin': '0–9', 'admin.numArabic': '٠–٩',
  'admin.content': 'Lesson',
  'admin.grade': 'Year of education', 'admin.sublevel': 'Level',
  'admin.rules': 'Rules', 'admin.rule': 'Matching rule', 'admin.target': 'Sum target',
  'admin.board': 'Board', 'admin.rows': 'Rows', 'admin.cols': 'Columns',
  'admin.range': 'Number range', 'admin.min': 'Smallest', 'admin.max': 'Largest',
  'admin.digits': 'Digits per number',
  'admin.adjacency': 'Require tiles to be connected',
  'admin.adjacencyHelp': 'Off for Grades 1–2: young players should never be blocked for a spatial reason. On from Grade 3, where it becomes the puzzle.',
  'admin.timer': 'Round timer (seconds)', 'admin.timerOff': 'No timer',
  'admin.adds': 'Add-row allowance', 'admin.hints': 'Hint allowance',
  'admin.penalty': 'Points lost per mistake',
  'admin.solvable': 'Only use boards that can be fully cleared',
  'admin.equalMultiples': 'Allow a number to pair with itself',
  'admin.oneFactor': 'Allow 1 to pair with everything',
  'admin.presets': 'Presets',
  'admin.presetName': 'Preset name', 'admin.save': 'Save preset', 'admin.load': 'Load', 'admin.delete': 'Delete',
  'admin.noPresets': 'No saved presets yet.',
  'admin.preview': 'Live preview',
  'admin.custom': 'Custom',
  'admin.presetPlaceholder': 'e.g. Tuesday warm-up',
  'admin.presetsServer': 'Saved to your teacher account — available on any device.',
  'admin.presetsLocal': 'Saved in this browser. Sign in as a teacher to keep them with your account.',

  'nav.badges': 'Badges',
  'nav.home': 'Home',
  'nav.practice': 'Practice',
  'nav.leave': 'Leave',

  'home.blurb': 'Match the numbers before the clock runs out. Join your class with the code on the board, or practise on your own.',
  'home.joinTitle': 'Join a class',
  'home.joinHint': 'Your teacher will read out a six-letter code.',
  'home.code': 'Class code',
  'home.go': 'Go',
  'home.practiceTitle': 'Practise on your own',
  'home.practiceHint': 'Every grade, every level, no class needed.',
  'home.practiceGo': 'Open practice',
  'home.teacherTitle': "I'm a teacher",
  'home.teacherHint': 'Run a class session, see the leaderboard, tune the levels.',
  'home.teacherGo': 'Teacher sign-in',

  'join.title': 'Join {code}',
  'join.nickname': 'Your name',
  'join.pin': 'Your 4-digit PIN',
  'join.pinHint': 'Pick a PIN you will remember. It keeps your badges yours — nobody else can play as you.',
  'join.go': 'Join the class',
  'join.joining': 'Joining…',
  'join.err.no_session': 'No class is running with that code right now.',
  'join.err.bad_pin': 'That name is taken and the PIN does not match.',
  'join.err.session_ended': 'That session has finished.',
  'join.err.invalid': 'Check the code, your name and a 4-digit PIN.',
  'join.err.offline': 'Cannot reach the class server. Check the Wi-Fi and try again.',

  'live.lobby': 'Waiting for your teacher to start',
  'live.lobbyHint': 'You are in. Keep this page open.',
  'live.countdown': 'Get ready…',
  'live.paused': 'Paused by your teacher',
  'live.round': 'Round {a} of {b}',
  'live.results': 'Round results',
  'live.final': 'Final standings',
  'live.ended': 'Session finished',
  'live.waitingNext': 'Waiting for the next round',
  'live.reconnecting': 'Reconnecting…',
  'live.you': 'you',
  'live.players': '{n} playing',
  'live.rank': 'Rank',
  'live.cleared': 'Cleared',
  'live.leaveAsk': 'Leave the class session?',

  'host.title': 'Class session',
  'host.joinAt': 'Join at',
  'host.code': 'Class code',
  'host.start': 'Start',
  'host.next': 'Next round',
  'host.skip': 'End round',
  'host.pause': 'Pause',
  'host.resume': 'Resume',
  'host.end': 'End session',
  'host.kick': 'Remove',
  'host.noPlayers': 'Nobody has joined yet.',
  'host.players': 'Players',
  'host.lobby': 'Lobby',
  'host.endAsk': 'End the session for everyone?',
  'host.projector': 'Projector view',

  'teacher.signIn': 'Teacher sign-in',
  'teacher.signUp': 'Create a teacher account',
  'teacher.email': 'Email',
  'teacher.password': 'Password',
  'teacher.name': 'Your name',
  'teacher.regCode': 'Invitation code',
  'teacher.submitIn': 'Sign in',
  'teacher.submitUp': 'Create account',
  'teacher.toSignUp': 'No account yet? Create one',
  'teacher.toSignIn': 'Already have an account? Sign in',
  'teacher.signOut': 'Sign out',
  'teacher.classes': 'Your classes',
  'teacher.newClass': 'New class',
  'teacher.className': 'Class name',
  'teacher.create': 'Create class',
  'teacher.noClasses': 'No classes yet. Create one to get a join code.',
  'teacher.students': '{n} students',
  'teacher.roster': 'Students',
  'teacher.leaderboard': 'Class leaderboard',
  'teacher.startSession': 'Start a session',
  'teacher.mode': 'Session type',
  'teacher.lockstep': 'Lockstep',
  'teacher.lockstepHint': 'Timed rounds. You advance the class together.',
  'teacher.race': 'Race',
  'teacher.raceHint': 'Free pace. The first board cleared wins the round.',
  'teacher.rounds': 'Rounds',
  'teacher.roundsHint': 'Pick the levels this session will play, in order.',
  'teacher.launch': 'Open the projector',
  'teacher.deleteClass': 'Delete class',
  'teacher.deleteAsk': 'Delete this class, its students and their badges?',
  'teacher.removeStudent': 'Remove',
  'teacher.removeAsk': 'Remove this student? Their badges and scores go with them.',
  'teacher.live': 'Live now',
  'teacher.err.bad_credentials': 'That email and password do not match.',
  'teacher.err.email_taken': 'There is already an account with that email.',
  'teacher.err.weak_password': 'Use at least 10 characters.',
  'teacher.err.registration_closed': 'Registration is closed on this server.',
  'teacher.err.bad_registration_code': 'That invitation code is not right.',
  'teacher.err.bad_email': 'Check the email address.',
  'teacher.err.bad_name': 'Enter your name.',
  'teacher.err.generic': 'Something went wrong. Try again.',
  'teacher.badges': 'Badges',
  'teacher.score': 'Score',
  'teacher.streak': 'Streak',
  'teacher.copy': 'Copy link',
  'teacher.copied': 'Copied',

  'rule.productTo': 'Tap two numbers that multiply to {n}',
  'rule.even': 'Tap every EVEN number',
  'rule.odd': 'Tap every ODD number',
  'rule.prime': 'Tap every PRIME number',
  'rule.notPrime': 'Tap every number that is NOT prime',
  'rule.multiplesOf': 'Tap every multiple of {n}',
  'rule.factorsOf': 'Tap every factor of {n}',
  'topic.even': 'Even numbers',
  'topic.odd': 'Odd numbers',
  'topic.mult2': 'Multiples of 2',
  'topic.multN': 'Multiples of a number',
  'topic.factors': 'Factors of a number',
  'topic.prime': 'Prime numbers',
  'topic.notPrime': 'Not prime',
  'topic.product12': 'Multiplying to 12',
  'topic.productN': 'Multiplying to a number',
  'hud.found': 'Found',
  'msg.found': '{a} — {n} to go',
  'msg.foundAll': 'Found them all!',
  'msg.notEven': '{a} is not even',
  'msg.notOdd': '{a} is not odd',
  'msg.notPrimeMiss': '{a} is not prime',
  'msg.isPrimeMiss': '{a} IS prime',
  'msg.notMultiple': '{a} is not a multiple of {t}',
  'msg.notFactor': '{a} is not a factor of {t}',
  'msg.matchFactor': '{a} × {k} = {b}',
  'msg.matchDivide': '{b} ÷ {a} = {k}',
  'msg.noMatchMultiple': '{a} is not a multiple of {b}',
  'msg.matchProduct': '{a} × {b} = {t}',
  'msg.noMatchProduct': '{a} × {b} ≠ {t}',
  'praise.1': 'Well done!',
  'praise.2': 'Excellent!',
  'praise.3': 'Brilliant!',
  'praise.4': 'Keep going!',
  'praise.5': 'Perfect!',
  'admin.mechanic': 'How it is played',
  'admin.mechanicPair': 'Tap two that go together',
  'admin.mechanicHunt': 'Tap every one that fits',
  'admin.density': 'How much of the board answers the question',
  'admin.densityHelp': 'Too high and there is nothing to reject; too low and the hunt is an empty field. Just under half works best.',
  'admin.targetProduct': 'Product target',
  'admin.targetMultiple': 'Multiples of',
  'admin.targetFactor': 'Factors of',
  'admin.presentation': 'Presentation',
  'admin.textSize': 'Text and number size',
  'admin.textNormal': 'Normal',
  'admin.textLarge': 'Larger',
  'admin.textHuge': 'Largest',
  'admin.textProjector': 'Big screen / TV',
  'rule.multipleOfUpTo': 'Tap a number and its multiple, up to × {k}',
  'rule.multiplesOfUpTo': 'Tap every multiple of {n}, up to {n} × {k}',
  'msg.overMultiplier': '{b} = {a} × {k} — this round goes up to × {m}',
  'msg.reshuffled': 'no pairs left, so the board was reshuffled',
  'admin.maxMultiplier': 'Multiplied by up to',
  'admin.maxMultiplierHelp': 'Keeps the board to the times tables the class has reached: at × 3, 4 ↔ 12 counts but 4 ↔ 16 does not.',
  'admin.noLimit': 'No limit',
  'admin.rangeFrom': 'Numbers from',
  'admin.rangeTo': 'to',
  'admin.rangeQuick': 'Quick choice',
  'admin.warnSum': 'No two numbers in this range add up to {t}, so some tiles will fall outside it.',
  'admin.warnProduct': 'No two numbers in this range multiply to {t}, so 1 × {t} will be used.',
  'admin.warnMultiple': 'This range is too narrow for a number and its double — widen it, or some tiles will fall outside it.',
  'admin.warnNoMultiples': 'There is no multiple of {n} in this range, so there is nothing to find.',
  'admin.warnMultiplesCap': 'Multiples of {n} up to × {k} reach {x}. Raise the largest number to {x} to show them all.',
  'admin.warnFactors': 'There is no factor of {n} in this range, so there is nothing to find.',
  'admin.textSizeHelp': 'Larger tiles read from the back of a classroom, and fewer of them fit across a phone.',
  'admin.multipleDisplay': 'Show a correct multiples pair as',
  'admin.celebration': 'Encouragement',
  'admin.celebrationSparks': 'Sparks only',
  'admin.celebrationWord': 'Word of praise',
  'admin.celebrationFull': 'Full celebration',
  'admin.celebrationHelp': 'Sparks and a chime, plus a word of praise, plus confetti and applause on a streak.',
  'admin.decorations': 'Drawings on the plain themes',
  'admin.decorationsHelp': 'Ruler, compass and pencil draw themselves into the margins of Paper & Marker as the round goes on.',
  'admin.puzzle': 'Reveal a picture under the tiles',
  'admin.puzzleHelp': 'The grid has to hold still for the picture, so cleared rows stay in place instead of collapsing. "Add row" still works: new rows go below the picture.',
  'admin.puzzleScene': 'Picture',
  'admin.sceneRandom': 'A different one each board',
  'admin.sceneUpload': 'Upload a picture',
  'admin.sceneRandomHelp': 'Each board draws one of the built-in pictures or one of yours. Every picture you upload joins the draw.',
  'media.localOnly': 'Saved in this browser only, so they stay after a refresh. Sign in as a teacher to keep them on your account and use them in class.',
  'media.thisBrowser': 'this browser only',
  'scene.rocket': 'Rocket',
  'scene.cat': 'Cat',
  'scene.boat': 'Boat',
  'scene.tree': 'Tree',
  'scene.whale': 'Whale',
  'scene.balloon': 'Balloon',
  'curriculum.builtin': 'Grades 1–6 (built in)',
  'curriculum.title': 'Curriculum',
  'curriculum.subtitle': 'Your own stages and exercises. Rename them, reorder them, throw the rest away.',
  'curriculum.mine': 'Your curricula',
  'curriculum.duplicate': 'Duplicate the built-in one',
  'curriculum.new': 'Start an empty one',
  'curriculum.readOnly': 'Built in — duplicate it to make it yours.',
  'curriculum.addStage': 'Add a stage',
  'curriculum.addLevel': 'Add an exercise',
  'curriculum.stageName': 'Stage name',
  'curriculum.levelName': 'Exercise name',
  'curriculum.countsAs': 'Counts as year',
  'curriculum.countsAsHelp': 'Badges are earned against a school year, so a renamed stage still has to say which year it stands for.',
  'curriculum.up': 'Move up',
  'curriculum.down': 'Move down',
  'curriculum.remove': 'Remove',
  'curriculum.removeStageAsk': 'Remove this stage and every exercise in it?',
  'curriculum.edit': 'Edit',
  'curriculum.save': 'Save curriculum',
  'curriculum.saved': 'Saved',
  'curriculum.saving': 'Saving…',
  'curriculum.name': 'Curriculum name',
  'curriculum.empty': 'No stages yet. Add one, or duplicate the built-in curriculum.',
  'curriculum.useForClass': 'Use for this class',
  'curriculum.usingBuiltin': 'This class uses the built-in Grades 1–6.',
  'curriculum.deleteAsk': 'Delete this curriculum? Classes using it fall back to Grades 1–6.',
  'curriculum.levels': '{n} exercises',
  'curriculum.pick': 'Choose the exercises this session will play, in order.',
  'media.title': 'Your pictures and recordings',
  'media.subtitle': 'Pictures appear under puzzle boards. Recordings replace the praise sound for your classes.',
  'media.pictures': 'Puzzle pictures',
  'media.voices': 'Encouragement recordings',
  'media.upload': 'Upload',
  'media.uploading': 'Uploading…',
  'media.none': 'Nothing uploaded yet.',
  'media.usage': '{a} of {b} used',
  'media.deleteAsk': 'Delete this file?',
  'media.err.bad_type': 'That file type is not accepted.',
  'media.err.too_large': 'That file is too large.',
  'media.err.quota_full': 'Your storage is full — delete something first.',
  'media.err.too_many': 'You have reached the limit for this kind of file.',
  'media.err.generic': 'Upload failed. Try again.',
  'media.voiceHelp': 'Short clips — «أحسنت», «ممتاز». One is played at random after a correct answer.',
  'media.pictureHelp': 'A class photo or a topic picture, revealed piece by piece as the board clears.',
  'class.of': "{name}'s class",
  'teacher.yourName': 'Your name',
  'tier.bronze': 'Bronze', 'tier.silver': 'Silver', 'tier.gold': 'Gold',

  'ach.unlocked': 'Badge unlocked',
  'ach.points': '+{n} pts',

  'trophy.title': 'Trophy case',
  'trophy.subtitle': 'Every badge in the game, and how close you are to the rest.',
  'trophy.earned': '{a} of {b} earned',
  'trophy.points': 'Badge points',
  'trophy.streak': 'Day streak',
  'trophy.matches': 'Pairs matched',
  'trophy.cleared': 'Boards cleared',
  'trophy.rounds': 'Rounds played',
  'trophy.bestCombo': 'Best combo',
  'trophy.locked': 'Locked',
  'trophy.progress': '{a} / {b}',
  'trophy.on': 'Earned {d}',
  'trophy.reset': 'Reset my progress',
  'trophy.resetAsk': 'Clear every badge and statistic on this device? This cannot be undone.',
  'trophy.days': '{n} days',

  'fam.mastery': 'Mastery',
  'fam.speed': 'Speed',
  'fam.persistence': 'Persistence',
  'fam.competition': 'Competition',
  'fam.mastery.d': 'Earned by finishing what you start.',
  'fam.speed.d': 'Earned by the clock and the streak.',
  'fam.persistence.d': 'Earned by coming back.',
  'fam.competition.d': 'Earned against the rest of the class.',

  'ach.title': 'Achievement',
  'ach.first_clear': 'First Clear', 'ach.first_clear.d': 'You cleared your first board',
  'ach.perfect_board': 'Perfect Board', 'ach.perfect_board.d': 'Cleared with no mistakes',
  'ach.no_add_clear': 'No Help Needed', 'ach.no_add_clear.d': 'Cleared without adding a row',
  'ach.unaided': 'Untouchable', 'ach.unaided.d': 'Cleared with no hints, no adds, no mistakes',
  'ach.grade_ace': 'Grade Ace', 'ach.grade_ace.d': 'Every level in the year completed',
  'ach.quick_off': 'Quick Off the Mark', 'ach.quick_off.d': 'Five matches in the first 15 seconds',
  'ach.speed_demon': 'Speed Demon', 'ach.speed_demon.d': 'Cleared a board inside 30 seconds',
  'ach.combo_5': 'Combo ×5', 'ach.combo_5.d': 'Five matches without a mistake',
  'ach.combo_10': 'Combo ×10', 'ach.combo_10.d': 'Ten matches without a mistake',
  'ach.combo_20': 'Combo ×20', 'ach.combo_20.d': 'Twenty matches without a mistake',
  'ach.century': 'Century', 'ach.century.d': '100 pairs matched all-time',
  'ach.marathon': 'Marathon', 'ach.marathon.d': '1,000 pairs matched all-time',
  'ach.regular': 'Regular', 'ach.regular.d': 'Played ten rounds',
  'ach.streak_3': 'Three in a Row', 'ach.streak_3.d': 'Played three days running',
  'ach.streak_7': 'Week Strong', 'ach.streak_7.d': 'Played seven days running',
  'ach.podium': 'On the Podium', 'ach.podium.d': 'Finished in the top three',
  'ach.champion': 'Champion', 'ach.champion.d': 'Finished first in the class',
  'ach.podium_5': 'Five-Time Podium', 'ach.podium_5.d': 'Top three in five sessions',
  'ach.comeback': 'Comeback', 'ach.comeback.d': 'Last to top three in one round',
} as const;

export type StringKey = keyof typeof en;
